import React from 'react';
import { View } from '@fairygodboss/ui';

export const DividerSVG = ({ width }) => {
    return (
        <View>
            <svg
                width={`${width}%`}
                height="2"
                // viewBox={`0 0 ${width} 2`}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width={`${width}%`} height="2" fill="#B394F2" />
            </svg>
        </View>
    );
};

export const ConvincerSVG = () => (
    <svg
        width="270"
        height="110"
        viewBox="0 0 270 110"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_878_6813)">
            <path
                d="M229.5 101.198L220.7 97.9946L217.497 106.797L226.297 110L229.5 101.198Z"
                fill="#982EA9"
            />
            <rect
                width="9.36528"
                height="9.367"
                transform="matrix(-0.939674 -0.342072 -0.341976 0.939709 152.004 15.2036)"
                fill="#982EA9"
            />
            <path
                d="M180.925 92.9951L174.502 96.8549L178.361 103.279L184.784 99.4187L180.925 92.9951Z"
                fill="#E3C5E7"
            />
            <path
                d="M46.7354 93.5325L39.2831 92.7495L38.4995 100.202L45.9517 100.985L46.7354 93.5325Z"
                fill="#B394F2"
            />
            <rect
                width="4.68458"
                height="4.68505"
                transform="matrix(-0.990265 -0.139198 -0.139149 0.990272 97.8042 17.6516)"
                fill="#BD79C8"
            />
            <rect
                width="4.68458"
                height="4.68505"
                transform="matrix(-0.566367 -0.824154 -0.8241 0.566446 208.013 33.8594)"
                fill="#BD79C8"
            />
            <rect
                opacity="0.8"
                width="7.49326"
                height="7.49356"
                transform="matrix(-0.828994 -0.559257 -0.559129 0.829081 116.913 40.1885)"
                fill="#B394F2"
            />
            <rect
                width="5.61978"
                height="5.62033"
                transform="matrix(-0.97814 -0.207952 -0.207872 0.978157 174.443 34.896)"
                fill="#B394F2"
            />
            <rect
                width="5.61978"
                height="5.62033"
                transform="matrix(-0.97814 -0.207952 -0.207872 0.978157 104.177 100.163)"
                fill="#982EA9"
            />
            <path
                d="M228.496 77.9963C226.585 75.1242 220.69 70.4089 212.398 74.5239"
                stroke="#BD79C8"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M62.9999 83.2926C65.0423 87.1053 70.9216 93.6155 78.099 89.1548"
                stroke="#982EA9"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.7952 53.1486C65.1732 52.8732 64.2632 52.3588 63.2505 51.1041C63.0541 51.1109 62.6364 51.9557 62.7083 52.7893L62.7095 52.8035C62.7924 53.7705 62.9482 55.5885 65.8085 56.8219C65.2302 56.9234 64.4238 56.91 63.6484 56.6024C63.6952 57.9384 64.9277 60.4035 68.7086 60.5227C68.5147 61.0312 67.5423 61.1488 66.9506 61.2112C67.5885 62.4433 69.2265 63.1804 71.0934 63.1572C71.2858 63.1548 71.5458 63.1253 71.8434 63.0916C72.5057 63.0165 73.3546 62.9203 74.06 63.0539C75.2169 63.273 75.67 63.4467 76.4886 64.3859C76.4857 64.3037 76.5111 64.1306 76.547 63.8859C76.7644 62.4032 77.3674 58.2917 74.402 55.8518C74.3458 55.8056 74.291 55.76 74.2368 55.7151C73.0702 54.7472 72.2626 54.0771 66.7952 53.1486ZM67.7096 54.4789C66.547 54.2815 64.9108 53.9974 63.9077 53.2862C64.1538 54.158 64.3689 54.4541 64.8653 54.9169C65.5061 55.5205 67.8564 56.4833 69.2784 57.0658C69.4766 57.147 69.6568 57.2209 69.8118 57.2853L69.7842 57.2901C69.2692 57.3805 66.0805 57.9404 65.4192 58.0327C66.1424 58.9254 67.4466 59.4731 70.333 59.429C70.2967 59.5151 70.2538 59.6525 70.2019 59.8191C70.0203 60.401 69.7278 61.3387 69.2177 61.6888C69.2912 61.7389 69.7224 61.9569 70.9739 62.0051C71.181 62.0025 71.4346 61.974 71.7225 61.9418C72.0532 61.9047 72.4292 61.8626 72.8325 61.8486C73.5871 61.8223 74.6192 61.8569 75.5727 62.2685C75.573 62.264 75.5734 62.259 75.5738 62.2535C75.6059 61.8174 75.8552 58.4248 73.5678 56.6332C73.509 56.5871 73.4522 56.5423 73.3969 56.4987C72.293 55.6283 71.7976 55.2376 67.7096 54.4789Z"
                fill="#BD79C8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M63.908 53.2864C64.9111 53.9976 66.5474 54.2817 67.7099 54.4791C72.0026 55.2757 72.334 55.6666 73.5682 56.6334C75.8843 58.4475 75.5996 61.9029 75.5731 62.2687C74.6195 61.8571 73.5874 61.8224 72.8329 61.8487C72.0783 61.875 71.4192 61.9996 70.9743 62.0053C69.7228 61.9571 69.2915 61.7391 69.2181 61.6889C69.8742 61.2386 70.1704 59.8161 70.3333 59.4292C67.447 59.4732 66.1427 58.9255 65.4195 58.0328C66.0941 57.9387 69.3977 57.3582 69.8121 57.2854C68.5453 56.7589 65.5958 55.6048 64.8656 54.9171C64.3693 54.4542 64.1541 54.1581 63.908 53.2864Z"
                fill="#BD79C8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M200.091 55.5045C201.94 55.4195 203.027 54.9701 204.33 53.708C204.548 53.7425 204.899 54.7433 204.705 55.6642L204.701 55.6799C204.476 56.7484 204.053 58.7571 200.69 59.7419C201.322 59.9346 202.224 60.0303 203.133 59.7932C202.897 61.2788 201.183 63.8624 196.944 63.4765C197.091 64.0709 198.161 64.3357 198.813 64.4866C197.932 65.775 196.002 66.3732 193.92 66.0911C193.706 66.062 193.419 65.9934 193.091 65.9148C192.362 65.7401 191.427 65.5161 190.621 65.5685C189.299 65.6544 188.769 65.7861 187.726 66.7226C187.741 66.6312 187.736 66.4344 187.73 66.1563C187.69 64.4707 187.58 59.7966 191.226 57.479C191.295 57.4351 191.362 57.3918 191.429 57.3491C192.864 56.4283 193.858 55.7909 200.091 55.5045ZM198.888 56.8646C200.213 56.8037 202.079 56.711 203.297 56.0545C202.903 56.9942 202.622 57.2954 202.004 57.7441C201.206 58.3302 198.449 59.0827 196.781 59.538C196.549 59.6015 196.337 59.6592 196.156 59.7099L196.186 59.719C196.748 59.8906 200.233 60.9536 200.959 61.1474C200.029 62.045 198.497 62.4776 195.28 62.0322C195.309 62.1334 195.338 62.2927 195.373 62.4858C195.496 63.1605 195.694 64.2478 196.216 64.7087C196.127 64.7547 195.615 64.9389 194.211 64.8209C193.98 64.7896 193.701 64.723 193.384 64.6475C193.02 64.5607 192.605 64.4621 192.157 64.391C191.318 64.2581 190.16 64.1551 189.039 64.4839C189.039 64.4788 189.04 64.4731 189.04 64.467C189.064 63.9755 189.25 60.1529 192.05 58.4661C192.122 58.4227 192.192 58.3805 192.259 58.3394C193.611 57.5189 194.218 57.1506 198.888 56.8646Z"
                fill="#B394F2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M203.297 56.055C202.079 56.7115 200.213 56.8041 198.888 56.865C193.984 57.1654 193.561 57.5564 192.05 58.4665C189.215 60.1744 189.06 64.0721 189.039 64.4843C190.16 64.1555 191.318 64.2585 192.157 64.3914C192.996 64.5244 193.715 64.754 194.211 64.8213C195.615 64.9393 196.127 64.7551 196.216 64.7092C195.545 64.1163 195.409 62.4871 195.28 62.0326C198.497 62.478 200.029 62.0454 200.959 61.1478C200.218 60.9501 196.608 59.8484 196.155 59.7103C197.642 59.2962 201.094 58.4123 202.004 57.7445C202.622 57.2958 202.903 56.9946 203.297 56.055Z"
                fill="#B394F2"
            />
            <ellipse
                cx="135"
                cy="76.9961"
                rx="24"
                ry="23.9985"
                fill="#982EA9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M146.703 64.1689C144.894 66.5776 143.228 67.5972 140.218 68.217C129.598 70.4032 128.488 71.7292 126.19 73.7591C119.925 79.2913 122.852 88.7446 122.852 89.8294C124.319 88.0225 125.154 87.6687 127.3 87.1844C129.196 86.7563 131.686 87.21 132.846 87.1844C136.333 87.1061 139.344 85.6234 140.455 83.2813C139.345 83.2033 137.522 83.0469 137.127 82.1101C144.179 81.6417 146.319 76.9588 146.319 74.4611C144.892 75.0859 143.387 75.1634 142.3 75.0115C147.587 72.5101 147.734 69.0842 147.826 67.2802C147.905 65.7192 147.07 64.1689 146.703 64.1689Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M145.618 68.2864C143.792 69.6795 140.755 70.3164 138.597 70.7606C130.633 72.5273 130.04 73.2788 127.799 75.1641C123.593 78.7019 124.35 85.1352 124.423 85.8166C126.177 84.986 128.102 84.8542 129.513 84.8542C130.924 84.8542 132.162 85.044 132.994 85.0256C135.327 84.8542 136.118 84.4191 136.252 84.3207C134.998 83.5226 134.352 80.8859 134.022 80.1739C139.414 80.0685 141.814 78.961 143.106 77.2471C141.84 77.1153 135.634 76.2462 134.855 76.1373C137.186 75.0718 142.618 72.725 143.937 71.3935C144.833 70.497 145.216 69.9301 145.618 68.2864Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_878_6813">
                <rect width="270" height="110" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
